import {get, number_format} from "../util";
import {assetUrl} from "../utils/assetUrl";

export function update_motes() {
    get('?do=updateMotes', {
        air: (document.querySelector('.js-mote-amount[data-mote="air"]') as HTMLInputElement).value,
        death: (document.querySelector('.js-mote-amount[data-mote="death"]') as HTMLInputElement).value,
        earth: (document.querySelector('.js-mote-amount[data-mote="earth"]') as HTMLInputElement).value,
        fire: (document.querySelector('.js-mote-amount[data-mote="fire"]') as HTMLInputElement).value,
        life: (document.querySelector('.js-mote-amount[data-mote="life"]') as HTMLInputElement).value,
        soul: (document.querySelector('.js-mote-amount[data-mote="soul"]') as HTMLInputElement).value,
        water: (document.querySelector('.js-mote-amount[data-mote="water"]') as HTMLInputElement).value
    },(data : any) => {
        ['air','death','earth','fire','life','soul','water'].forEach((mote) => {
            let row = document.querySelector('.js-mote[data-mote="' + mote + '"]') as HTMLElement;
            (row.querySelector('.js-mote-wisp_min') as HTMLElement).innerHTML = data[mote].wisp_min;
            (row.querySelector('.js-mote-wisp_max') as HTMLElement).innerHTML = data[mote].wisp_max;
            (row.querySelector('.js-mote-essence_min') as HTMLElement).innerHTML = data[mote].essence_min;
            (row.querySelector('.js-mote-essence_max') as HTMLElement).innerHTML = data[mote].essence_max;
            (row.querySelector('.js-mote-quintessence_min') as HTMLElement).innerHTML = data[mote].quintessence_min;
            (row.querySelector('.js-mote-quintessence_max') as HTMLElement).innerHTML = data[mote].quintessence_max;
            (row.querySelector('.js-mote-quintessence_price_min') as HTMLElement).innerHTML = '$' + data[mote].quintessence_price_min;
            (row.querySelector('.js-mote-quintessence_price_max') as HTMLElement).innerHTML = '$' + data[mote].quintessence_price_max;
        });
    });
}

export function crafting_link(crafting_id : number) {
    return crafting_id !== null ? `&nbsp;<a href="/nw/crafting/${crafting_id}" class="text-decoration-none text-info"><sup>[C]</sup></a>` : '';
}

export function nwdb_link(id : string) {
    return `&nbsp;<a href="https://nwdb.info/db/item/${id}" class="text-decoration-none text-secondary" target="_blank"><sup>[DB]</sup></a>`;
}

export function gold(gold : string, color : string | null = null) {
    let string = '';
    if(color !== null) {
        string += `<span style="color: ` + color + `">`;
    }
    string += `<img src="${assetUrl('nw/icons/gold.webp')}" class="img-fluid" style="width: 22px" /> ${gold}`;
    if(color !== null) {
        string += `</span>`;
    }
    return string;
}
